import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import StarStarredIcon from '@atlaskit/icon/core/star-starred';
import StarUnstarredIcon from '@atlaskit/icon/core/star-unstarred';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
import Tooltip from '@atlaskit/tooltip';
import React, { useState } from 'react';
import { RATING_TITLES, TOTAL_RATINGS } from './RatingsSelector.constants';
import { ClearButton, Container, RatingButton, StarIconWrapper } from './RatingsSelector.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RatingsSelector = _ref => {
  let {
    currentRating = 0,
    onRatingsChange
  } = _ref;
  const [hoverRating, setHoverRating] = useState(0);
  const handleOnClick = index => {
    onRatingsChange === null || onRatingsChange === void 0 ? void 0 : onRatingsChange(index);
  };
  const handleClear = () => {
    var _document$getElementB;
    setHoverRating(0);
    onRatingsChange === null || onRatingsChange === void 0 ? void 0 : onRatingsChange(0);
    (_document$getElementB = document.getElementById('rating-1')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
  };
  return /*#__PURE__*/_jsxs(Container, {
    children: [[...new Array(TOTAL_RATINGS)].map((_, index) => {
      const ratingIndex = index + 1;
      const highlightStar = ratingIndex <= (hoverRating || currentRating);
      return /*#__PURE__*/_jsx(Tooltip, {
        content: RATING_TITLES[index],
        delay: 0,
        children: tooltipProps => /*#__PURE__*/_jsx(RatingButton, _objectSpread(_objectSpread({}, tooltipProps), {}, {
          type: "button",
          id: "rating-".concat(ratingIndex),
          "data-testid": "rating-".concat(ratingIndex),
          onClick: () => handleOnClick(ratingIndex),
          onMouseEnter: () => setHoverRating(ratingIndex),
          onMouseLeave: () => setHoverRating(currentRating),
          "aria-label": "".concat(ratingIndex, " star out of ").concat(TOTAL_RATINGS, " stars"),
          "aria-pressed": "false",
          children: /*#__PURE__*/_jsx(StarIconWrapper, {
            isFilledStar: highlightStar,
            children: highlightStar ? /*#__PURE__*/_jsx(StarStarredIcon, {
              label: "StarFilled",
              color: "var(--ds-icon-accent-orange, #E56910)",
              LEGACY_size: "large"
            }) : /*#__PURE__*/_jsx(StarUnstarredIcon, {
              label: "StarUnfilled",
              color: "var(--ds-icon-accent-gray, #758195)",
              LEGACY_size: "large"
            })
          })
        }))
      }, ratingIndex);
    }), currentRating > 0 && /*#__PURE__*/_jsx(ClearButton, {
      testId: "clear-rating",
      onClick: handleClear,
      iconBefore: /*#__PURE__*/_jsx(SelectClearIcon, {
        label: "Clear",
        primaryColor: "var(--ds-icon-subtle, #626F86)",
        size: "small"
      }),
      appearance: "subtle",
      children: "Clear"
    })]
  });
};